//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminCompanyFileController_delete,
  Response$AdminCompanyFileController_delete$Status$200,
  ResponseContentType$AdminCompanyFileController_delete,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminCompanyFileController_delete = () =>
  useApiClientMutation<
    Params$AdminCompanyFileController_delete,
    Response$AdminCompanyFileController_delete$Status$200[ResponseContentType$AdminCompanyFileController_delete]
  >({ method: 'AdminCompanyFileController_delete' });
